import React from "react"
import PropTypes from "prop-types"
import Section from "components/Section"
import Typeface from "components/Typeface"
import Typography from "@material-ui/core/Typography"
import { withStyles } from "@material-ui/core/styles"

const styles = theme => ({
	typefaces: {
		margin: theme.spacing ( -2 ),
		marginTop: theme.spacing ( 2 ),
		display: "flex",
		flexWrap: "wrap"
	}
})

class TypefacesSection extends React.Component {

	render () {
		const { classes, theme } = this.props
		const elements = Object.keys ( theme.typography )
			.filter ( e => theme.typography [ e ].constructor.name === "Object" )
			.map ( e => theme.typography [ e ] )
			.map ( e => ({
				family: e.fontFamily.replace ( /\'|,.+/g, "" ),
				weight: e.fontWeight
			}))
			.filter ( ( e, i, s ) =>
				s.findIndex ( j =>
					j.family === e.family && j.weight === e.weight
				) === i
			)
			.sort ( ( a, b ) =>
				a.family === b.family ?
				a.weight - b.weight :
				( a.family > b.family ? 1 : -1 )
			)
		return <Section id="typefaces" >
			<Typography variant="h5" >Typefaces</Typography>
			<div className={classes.typefaces} >
			{
				elements.map ( element => <Typeface
					key={`${element.family}-${element.weight}`}
					variant={element.family}
					weight={element.weight}
				/> )
			}
			</div>
		</Section>
	}

}

TypefacesSection.propTypes = {
	classes: PropTypes.object.isRequired
}

export default withStyles ( styles, { withTheme: true } ) ( TypefacesSection )
